import React, { ReactNode } from "react";
import { Box } from "@mui/material";

interface TabPanelProps {
  value: number;
  index: number;
  children?: ReactNode;
}

export const TabPanel = (props: TabPanelProps) => {
  const {value, index, children} = props;

  return (
      <Box sx={{width: '100%'}} hidden={value !== index}>
        {value === index && (
            <>
              {children}
            </>
        )}
      </Box>
  );
}